// extracted by mini-css-extract-plugin
export var disabled = "_m-a";
export var hierarchyLinkGray = "_m-4";
export var hierarchyLinkUnderline = "_m-3";
export var hierarchyPrimary = "_m-0";
export var hierarchySecondary = "_m-1";
export var hierarchyTertiary = "_m-2";
export var pressed = "_m-6";
export var themeAction = "_m-5";
export var themeDestructive = "_m-8";
export var themeNormal = "_m-7";
export var themeSuccess = "_m-9";